// service unification module
import _ from "lodash";

import featureFlagsServiceFactory from "./featureFlags";
import userServiceFactory from "./user";
import localizationServiceFactory from "./localization";

const services = [
  featureFlagsServiceFactory,
  userServiceFactory,
  localizationServiceFactory
];

const servicesMiddleware = store => next => action => {
  next(action);
  let serviceObjects = services.map(x => x(store, next, action));
  serviceObjects.forEach(
    val => (_.isFunction(val[action.type]) ? val[action.type]() : _.noop())
  );
};

export default servicesMiddleware;



// WEBPACK FOOTER //
// ./src/services/index.js